// src/providers/statProvider.ts
import { DataProvider } from "react-admin";
import { appConfig } from "@/commons";
import { HistoryVoucherType } from "@/types";
import { httpClient } from "@/utilities";

const apiUrl = appConfig.api.baseUrl;

export type StatProvider = Partial<DataProvider> & {
  getHistoryVoucher?: () => Promise<{ data: HistoryVoucherType[] }>;
};

const statProvider: StatProvider = {
  async getHistoryVoucher() {
    const { json } = await httpClient(`${apiUrl}/stats/historyvoucherentity`, {
      method: "GET",
    });

    const data = json?.data ?? json ?? [];

    return {
      data: Array.isArray(data) ? data : [],
    };
  },
};

export default statProvider;
